import React, { useEffect } from "react";
import { usePageMeta } from "../lib/usePageMeta";

/**
 * Landing route - serves the standalone marketing page at /public/landing.html
 * in a full-viewport iframe.
 *
 * Why iframe?
 *  - The marketing HTML is fully self-contained (Syne + DM Sans fonts, custom
 *    CSS variables, vanilla-JS theme switcher / flip-words / sticky bar /
 *    water-cursor effect / FAQ accordion). It was authored independently and
 *    must remain "exactly as written" per the design brief.
 *  - An iframe gives us perfect isolation: no CSS leakage either way, no
 *    React Router interference, all scripts run natively in the iframe's own
 *    document.
 *  - Internal nav links inside the iframe use target="_top" so /login, /about,
 *    etc. break out into the parent SPA and React Router takes over.
 */
export default function Landing() {
  usePageMeta({
    title: "Run your gym. Not spreadsheets.",
    description: "Fitnudge tracks your leads, trials, members and renewals so you always know exactly who to message on WhatsApp every morning.",
  });

  // Reset the host page so the iframe truly fills the viewport.
  useEffect(() => {
    const prevHtml = document.documentElement.style.cssText;
    const prevBody = document.body.style.cssText;
    document.documentElement.style.cssText = "margin:0;padding:0;height:100%;overflow:hidden";
    document.body.style.cssText = "margin:0;padding:0;height:100%;overflow:hidden";
    return () => {
      document.documentElement.style.cssText = prevHtml;
      document.body.style.cssText = prevBody;
    };
  }, []);

  return (
    <iframe
      src="/landing.html"
      title="Fitnudge - Run your gym, not spreadsheets."
      data-testid="landing-iframe"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        border: "none",
        margin: 0,
        padding: 0,
        zIndex: 0,
        background: "#05091a",
      }}
    />
  );
}
